import { RegularDrawdownClient } from "../../../../../../Wrap/Api/Drawdown/RegularDrawdown";
import { RegularDrawdown } from "../../../../../../Wrap/Models/Domains/Drawdown/RegularDrawdown";

export class GetRegularCrystallisationAction {
  public static getRegularCrystallisation(hierarchyId: string, onSuccess: (result: RegularDrawdown) => void, onError?: (error) => void) {
    const client = new RegularDrawdownClient();
    const promise = client.get(hierarchyId);
    promise.onSuccess((result) => {onSuccess(result)});
    promise.onError((error) => {if (onError) {onError(error)}});
  }
}
